import styled, { css } from 'styled-components';

import { AvatarWithTextSize } from './AvatarWithText.types';

interface LabelProps {
  size: AvatarWithTextSize;
  description: string;
}

interface LabelDescriptionProps {
  size: AvatarWithTextSize;
}

const AvatarWithText = styled.div`
  display: flex;
  align-items: center;
`;

const Label = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  margin: 0 0 0 12px;
`;

const Title = styled.p<LabelProps>`
  ${({ theme, size, description }) => css`
    margin: 0;

    ${description.length > 0 &&
    css`
      ${size === 'large' && theme.label.medium.bold}
      ${(size === 'small' || size === 'medium') && theme.label.small.bold}
    `}

    ${description.length === 0 &&
    css`
      ${(size === 'large' || size === 'medium') && theme.label.medium.bold}
      ${size === 'small' && theme.label.small.bold}
    `}
    

    color: ${theme.text.onSurface.strong};
  `}
`;

const Description = styled.p<LabelDescriptionProps>`
  ${({ size, theme }) => css`
    margin-top: ${size === 'large' ? '4px' : '0'};

    ${size === 'large' && theme.label.medium.normal}
    ${(size === 'small' || size === 'medium') && theme.label.small.normal}

    color: ${theme.text.onSurface.subtle};
  `}
`;

export { AvatarWithText, Label, Title, Description };
